
ko.bindingHandlers.phoneValue = {
    init: function (element, valueAccessor, allBindings, viewModel, context) {
        const iti = window.intlTelInput(element, {
            // any initialisation options go here
            preferredCountries: ['us', 'gb', 'in', 'de'],
            initialCountry: "auto",
            geoIpLookup: async function (success, failure) {
                const resp = await fetch('/account/ipinfo');
                const json = await resp.json();

                if (json && json.countryCode) {
                    success(json.countryCode.toLocaleLowerCase());
                } else {
                    success('us');
                }
            },
        });

        element.addEventListener('countrychange', (e) => {
            setValue();
        });

        element.addEventListener('change', (e) => {
            setValue();
        });

        function setValue() {
            const v = `+${iti.getSelectedCountryData().dialCode} ${element.value}`;
            valueAccessor()(v);
        }
    }
}